(function($){
    $('.elementor-heading-title.elementor-size-default').each(function(){
        var txt = $(this).html(), th = $(this);
        // $(this).html('');
        // th.html(txt + '<span style="visibility: hidden">ś</span>');
    })
    $('.elementor-heading-title.elementor-size-default').each(function(){
        var txt = $(this).html(), th = $(this);
        // th.html(txt.replace('_ś', ''));
    })

    if($('.woocommerce-form-login-toggle').length > 0){
        var html = $('.woocommerce-form-login-toggle').html();
        html = html.replace('Returning customer?', 'Masz już konto w naszym sklepie?');
        html = html.replace('Click here to login', 'Zaloguj się tutaj');
        $('.woocommerce-form-login-toggle').html(html);
    }

    if($('.woocommerce-account-fields .create-account .woocommerce-form__label').length > 0){
        var html = $('.woocommerce-account-fields .create-account .woocommerce-form__label span').html();
        html = html.replace('Create an account?', 'Utwórz konto w naszym sklepie');
        $('.woocommerce-account-fields .create-account .woocommerce-form__label span').html(html);
    }
})(jQuery)